<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="darkMode"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <v-divider class="mb-1" />

    <v-list dense nav>
      <v-list-item href="https://quickdeliverysystem.com" target="blank">
        <v-list-item-avatar class="align-self-center" color="white" contain>
          <v-img src="../../assets/logo.png" max-height="50">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-row> </template
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="display-1" v-text="'Quick delivery sys'" />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />
    <v-list shaped>
      <template v-for="(item, i) in computedItems">
        <base-item :key="`item-${i}`" :item="item" :method="null" />
      </template>
      <v-divider class="mb-2" />

      <!-- <v-list-item to="/app/trust">
        <v-list-item-icon>
          <v-icon>mdi-account-group-outline </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('drawer.trustClients')" />
        </v-list-item-content>
      </v-list-item> -->

      <v-list-item @click="logout">
        <v-list-item-icon>
          <v-icon>mdi-logout </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('drawer.logout')" />
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/app/plan">
        <v-list-item-icon>
          <v-icon>mdi-floor-plan </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('drawer.plan')" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list shaped> </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "appCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    logoutItem: {
      icon: "mdi-logout",
      title: "",
    },
    items: [
      {
        admin: 3,
        icon: "mdi-help-box-outline",
        title: "drawer.help",
        to: "/app/help",
        disabled: false,
      },
      {
        admin: 1,
        icon: "mdi-chart-bar",
        title: "drawer.analys",
        to: "/app/analysis",
        disabled: false,
      },
      {
        admin: 5,
        icon: "mdi-chart-bar",
        title: "drawer.analys",
        to: "/app/analysis",
        disabled: false,
      },
      {
        admin: 3,
        icon: "mdi-view-dashboard-variant-outline",
        title: "drawer.packages",
        to: "/app/packages",
        disabled: false,
      },
      {
        admin: 3,
        icon: "mdi-view-grid-plus-outline",
        title: "drawer.newpackages",
        to: "/app/packages/new",
        disabled: false,
      },
      {
        admin: null,
        icon: "mdi-map-marker",
        title: "drawer.track",
        to: "/app/track",
        disabled: false,
      },
      // {
      //   admin: null,
      //   icon: "mdi-call-split",
      //   title: "طلبات عبر الشبكة",
      //   to: " ",
      // },
      {
        admin: 1,
        icon: "mdi-message-text",
        title: "drawer.instructions",
        to: "/app/instructions",
        disabled: false,
      },
      {
        admin: null,
        icon: "mdi-store",
        title: "drawer.resorce",
        to: "/app/place",
        disabled: false,
      },
      {
        admin: null,
        icon: "mdi-truck",
        title: "drawer.vehicle",
        to: "/app/vehicle",
        disabled: false,
      },

      {
        admin: null,
        icon: "mdi-card-account-details",
        title: "drawer.employees",
        to: "/app/employees",
        disabled: false,
      },
      // {
      //   admin: null,
      //   icon: "mdi-brightness-5",
      //   title: "drawer.meta",
      //   to: "/app/meta/settings",
      // },
      {
        admin: 1,
        icon: "mdi-cog-outline",
        title: "drawer.setting",
        to: "/app/settings/",
        disabled: false,
      },
    ],
  }),

  computed: {
    ...mapState(["darkMode"]),

    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },
    logout() {
      this.$store.dispatch("users/logout");
    },
    // goTo(to, id_company) {
    //   // to hide the error
    //   this.$router.push(to + id_company).catch(() => {});
    // },
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
        margin-right: 24px
        margin-left: 12px !important

        +rtl()
        margin-left: 24px
        margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px
    .v-list-group--sub-group
      .v-list-item
        +ltr()
        padding-left: 8px

        +rtl()
        padding-right: 8px

      .v-list-group__header
        +ltr()
        padding-right: 0

        +rtl()
        padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          package: 0

        .v-list-group__header__prepend-icon
          package: 2

          +ltr()
          margin-right: 8px

          +rtl()
          margin-left: 8px
.mode
  display: flex
  align-items: center
  justify-content: space-between
  span
    font-size: 14px
</style>
